/* Persist the cart note.

   Horizon's cart is not a classic <form id="cart">, so a textarea with a `form`
   attribute submits nowhere and the note is silently dropped at checkout. This
   writes it through the cart API on pause and on blur, and says so, because a
   note that looks saved and is not costs a delivery instruction. */
(function () {
  var SAVED = 'Saved with your order and printed on the packing slip.';
  var SAVING = 'Saving…';
  var FAILED = 'Could not save the note — check your connection.';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  ready(function () {
    var ta = document.querySelector('[data-sv-note]');
    if (!ta) return;
    var status = document.querySelector('[data-sv-note-status]');
    var last = ta.value;
    var timer;

    function say(msg) { if (status) status.textContent = msg; }

    function save() {
      if (ta.value === last) return;
      last = ta.value;
      say(SAVING);
      var body = new URLSearchParams();
      body.append('note', ta.value);
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      }).then(function (r) {
        say(r.ok ? SAVED : FAILED);
      }).catch(function () { say(FAILED); });
    }

    ta.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(save, 700);
    });
    ta.addEventListener('blur', function () { clearTimeout(timer); save(); });
  });
})();
